"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelNextAction = void 0;
var tslib_1 = require("tslib");
var social_1 = require("@dp-instant/social");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var SocialFlowAction_1 = require("./SocialFlowAction");
var LevelStartAction_1 = require("./LevelStartAction");
var LevelNextAction = (function (_super) {
    tslib_1.__extends(LevelNextAction, _super);
    function LevelNextAction() {
        var _this = _super.call(this) || this;
        _this.TRACK_EVENT = "level_next";
        _this.onFailed = function () {
            throw new Error("Something went wrong");
        };
        return _this;
    }
    LevelNextAction_1 = LevelNextAction;
    LevelNextAction.prototype.launch = function (nextOpponent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nextOpponent) {
                            LevelNextAction_1.FREE_SOLO_ATTEMPTS--;
                            return [2, this.playNextSolo()];
                        }
                        if (!(nextOpponent === this.social.opponent)) return [3, 1];
                        return [2, this.gotoNextLevel()];
                    case 1: return [4, this.social.playWith(nextOpponent, true)];
                    case 2:
                        switch (_a.sent()) {
                            case social_1.SOCIAL_POPUP.ACCEPTED:
                                return [2, this.gotoNextLevel(true)];
                            case social_1.SOCIAL_POPUP.CANCELLED:
                                if (LevelNextAction_1.FREE_SOLO_ATTEMPTS > 0) {
                                    LevelNextAction_1.FREE_SOLO_ATTEMPTS--;
                                    return [2, this.playNextSolo()];
                                }
                        }
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    LevelNextAction.prototype.playNextSolo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all([this.social.playSolo(), this.gotoNextLevel()])];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    LevelNextAction.prototype.gotoNextLevel = function (waitForContextChange) {
        if (waitForContextChange === void 0) { waitForContextChange = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.levelStart.waitForContextChange = waitForContextChange;
                        return [4, this.levelStart.run()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    LevelNextAction.prototype.needToShowAD = function () {
        return false;
    };
    var LevelNextAction_1;
    LevelNextAction.FREE_SOLO_ATTEMPTS = Number.MAX_SAFE_INTEGER;
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesFlow.LevelStart),
        tslib_1.__metadata("design:type", LevelStartAction_1.LevelStartAction)
    ], LevelNextAction.prototype, "levelStart", void 0);
    LevelNextAction = LevelNextAction_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)(),
        tslib_1.__metadata("design:paramtypes", [])
    ], LevelNextAction);
    return LevelNextAction;
}(SocialFlowAction_1.SocialFlowAction));
exports.LevelNextAction = LevelNextAction;
//# sourceMappingURL=LevelNextAction.js.map